/* tslint:disable */
/* eslint-disable */
/**
 * compass-pro
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UserLocationRequest
 */
export interface UserLocationRequest {
    /**
     * 
     * @type {number}
     * @memberof UserLocationRequest
     */
    degrees_bearing?: number | null;
    /**
     * 
     * @type {number}
     * @memberof UserLocationRequest
     */
    latitude: number;
    /**
     * 
     * @type {number}
     * @memberof UserLocationRequest
     */
    longitude: number;
    /**
     * 
     * @type {number}
     * @memberof UserLocationRequest
     */
    meters_per_second_speed?: number | null;
    /**
     * 
     * @type {number}
     * @memberof UserLocationRequest
     */
    timestamp: number;
}

/**
 * Check if a given object implements the UserLocationRequest interface.
 */
export function instanceOfUserLocationRequest(value: object): value is UserLocationRequest {
    if (!('latitude' in value) || value['latitude'] === undefined) return false;
    if (!('longitude' in value) || value['longitude'] === undefined) return false;
    if (!('timestamp' in value) || value['timestamp'] === undefined) return false;
    return true;
}

export function UserLocationRequestFromJSON(json: any): UserLocationRequest {
    return UserLocationRequestFromJSONTyped(json, false);
}

export function UserLocationRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserLocationRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'degrees_bearing': json['degrees_bearing'] == null ? undefined : json['degrees_bearing'],
        'latitude': json['latitude'],
        'longitude': json['longitude'],
        'meters_per_second_speed': json['meters_per_second_speed'] == null ? undefined : json['meters_per_second_speed'],
        'timestamp': json['timestamp'],
    };
}

export function UserLocationRequestToJSON(json: any): UserLocationRequest {
    return UserLocationRequestToJSONTyped(json, false);
}

export function UserLocationRequestToJSONTyped(value?: UserLocationRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'degrees_bearing': value['degrees_bearing'],
        'latitude': value['latitude'],
        'longitude': value['longitude'],
        'meters_per_second_speed': value['meters_per_second_speed'],
        'timestamp': value['timestamp'],
    };
}

